import { render, staticRenderFns } from "./LpDetailDialog.vue?vue&type=template&id=2f1c62a8"
import script from "./LpDetailDialog.vue?vue&type=script&lang=js"
export * from "./LpDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports